import moment from '@/assets/js/moment.min'
import { mapActions, mapGetters } from 'vuex'
import {
  _COMMIT_LOG, _DOWNLOAD_INVOICE, ACCT_GET_ACCOUNT_INVOICES, ACCT_SEND_INVOICES,
} from '../store/actions.types'
export default {
  data: function () {
    return {
      windowSize: {
        x: 0,
        y: 0,
      },
    }
  },
  computed: {
    storeName: {
      get () {
        return `${process.env.VUE_APP_STORE_NAME}`
      },
    },
    businessName: {
      get () {
        return `${process.env.VUE_APP_BUSINESS_NAME}`
      },
    },
    businessAddress: {
      get () {
        return `${process.env.VUE_APP_BUSINESS_ADDRESS}`
      },
    },
    mailingAddress: {
      get () {
        return `${process.env.VUE_APP_MAILING_ADDRESS}`
      },
    },
    businessPhone: {
      get () {
        return `${process.env.VUE_APP_BUSINESS_PHONE}`
      },
    },
    powUrl: {
      get () {
        return `${process.env.VUE_APP_API_POW_URL}`
      },
    },
    headerPath: {
      get () {
        let path = '@/assets/ez_wave_A.png'
        switch (this.storeName) {
          case 'ezwave':
            path = 'https://bucket.ezwave.com/public/ez_wave_A.png'
            break
          case 'velociter':
            path = 'https://bucket.ezwave.com/public/vw_logo.png'
            break
        }
        return path
      },
    },
    drawerFilterSearch: {
      get () {
        return this.$store.state.drawerFilterSearch
      },
      set (val) {
        this.$store.commit('SET_DRAWER_FILTER_SEARCH', val)
      },
    },
    ...mapGetters({
      isStaff: 'authIsStaff',
    }),
  },
  methods: {
    ...mapActions({
      commitLog: _COMMIT_LOG,
      getInvoices: ACCT_GET_ACCOUNT_INVOICES,
      downloadInvoice: _DOWNLOAD_INVOICE,
      sendInvoices: ACCT_SEND_INVOICES,
    }),

    // datetime functions
    formatEpoch (value, format) {
      if (!value) {
        return 'null'
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      if (value.length > 12) {
        return moment.unix(value / 1000).format(format)
      }
      return moment.unix(value).format(format)
      // if (Number.isInteger(value)) {
      //   console.log('value is int:', value)
      // }
      // return moment(value).format(format)
    },
    formatEpochFromNow (value) {
      if (!value) {
        return 'null'
      }
      if (value.length > 12) {
        return moment.unix(value / 1000).fromNow()
      }
      return moment.unix(value).fromNow()
      // if (Number.isInteger(value)) {
      //   console.log('value is int:', value)
      // }
      // return moment(value).format(format)
    },

    formatDate (value, format, utc) {
      if (!format) {
        format = 'M/D/YYYY'
      }
      if (utc) {
        return moment.utc(value).format(format)
      }
      return moment(value).format(format)
    },
    dateNow (format) {
      if (!format) {
        format = 'M/D/YYYY'
      }
      return moment().format(format)
    },
    formateUserName (firstName, lastName) {
      if (firstName && firstName.length > 0 &&
        lastName && lastName.length > 0) {
        return `${lastName}, ${firstName}`
      }
      if (firstName && firstName.length > 0 && !lastName) {
        return `${firstName}`
      }
      if (!firstName &&
        lastName && lastName.length > 0) {
        return `${lastName}`
      }
      if (!firstName && !lastName) {
        return 'invalidName'
      }
    },
    changeQuery (key, val) {
      // Make a clean copy of the current query
      let queries = JSON.parse(JSON.stringify(this.$route.query))
      // console.log(this.$route)
      const currentPath = this.$route.path
      if (!queries) {
        queries = {
          [key]: val,
        }
      } else {
        queries[key] = val
      }
      this.$router.push({ path: currentPath, query: queries })
    },
    validateIsEmail (email) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    isInt (value) {
      return !isNaN(value) && (function (x) { return (x | 0) === x })(parseFloat(value))
    },
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      console.log(this.windowSize)
    },
  },
}
